/**
 * Wraps a fn in a thunk, delaying invocation. Equivalent to writing `() => fn(args)`
 * @param {Function} fn to be wrapped
 * @param {Any} ...args to be called by `fn`
 */

// eslint-disable-next-line
export const thunk = (fn: any) => (...args: any) => () => fn(...args);
